<template>
  <div id="app">
        <section class="block">
            <h3 class="text-left pt-5 pb-4">Upcoming Events</h3>
            <form @submit="formSubmit">
              <div class="row">
                <div class="col-md-6 pb-3 pb-md-0">
                  <vue-monthly-picker
                    v-model="selectedMonth" placeHolder="Filter by month/year" @selected="onDateSelect" :monthLabels="locale" :min="min" :max="max" >
                  </vue-monthly-picker>
                </div>
                <div class="col-md-6 select-list">
                  <select v-model="selectedCategory" name="category" id="category" class="form-control cat-select" tabindex="12" @change="onCategoryChange($event)">
                    <option value="0" selected>Filter by category</option>
                    <option v-for="(category) in eventCategories" :key="category.id" :value="category.slug">{{ category.name }}</option>
                  </select>
                  <span class="vmp-input-append"><i class="vmp-clear-icon"></i></span>
                </div>
              </div>
              <!-- <br>
              <button class="btn btn-primary">Submit</button> -->
            </form>
            <ArticlesList v-bind:category="this.selectedCategory" v-bind:month="this.selectedMonth" :key="componentKey" v-if="loaded" v-bind:class="{ loaded: loaded }" class="init"/>
        </section>
  </div>
</template>

<script>
import moment from 'moment'
import VueMonthlyPicker from 'vue-monthly-picker';
import axios from "axios";
import ArticlesList from "./components/ArticlesList";

export default {
  name: 'App',
  data () {
    return {
      // category: '',
      // selectedMonth: moment(''),
      // selectedMonth: null,
      selectedMonth: '',
      // min: null,
      max: null,
      min: moment().subtract(2, 'months'),
      locale: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      categoryPageCount: 1,
      eventCategories: [],
      // selectedCategory: 149
      selectedCategory: 0,
      componentKey: 0,
      loaded: false
    }
  },
  components: {
    VueMonthlyPicker,
    ArticlesList
  },
  async mounted() {
    try {
      return axios.get(
        `/wp-json/wp/v2/event_category/?page=1&per_page=100`
      ).then((response) => {
        // console.log(response.data);
        // console.log(response.status);
        // console.log(response.headers);
        // console.log(totalHeaders);
        // console.log(response.config);
        // this.min = moment().subtract(1, 'days').startOf('day').format('YYYY/MM');
        // console.log(moment().subtract(1, 'days').startOf('day'));
        // console.log(moment().subtract(1, 'days').startOf('day').format('YYYY/MM'));
        this.categoryPageCount = Number(response.headers['x-wp-totalpages']);
        // console.log(response.headers);
        this.eventCategories = response.data;
        this.loaded = true;
      }).catch(error => {
          console.log('category error: ',error.response)
      });
      
    } catch (error) {
      // throw error;
      console.log('Error Response:', error);
    }
  },
  methods: {
     /* eslint-disable no-unused-vars */
    formSubmit(e) {
        e.preventDefault();
    },
    onCategoryChange(event) {
      // console.log(event.target.value)
      // console.log('this.componentKey')
      // force re-renders of a component
      this.componentKey += 1;  
    },
    onDateSelect (value) {
      // console.log('Select', value)
      this.componentKey += 1;  
    }
     /* eslint-enable no-unused-vars */
  }
}
</script>

<style lang="scss">
#app {
  text-align: center;
  color: #2c3e50;
}
.vue-monthly-picker .month-year-display.input{
  border-radius: 0;
  box-shadow:none;
  font-size: 1rem;
}
select.cat-select{
  width: 100% !important;
  padding: 5px 10px !important;
  height: 35px !important;
  background-color: #fff !important;
  border-radius: 0 !important;
  font-size: 1rem !important;
  border-color: #dbdbdb !important;
  color: #363636 !important;
}
// Safari and Firefox Select box fix
.select-list {
    position: relative;

    &:after{
        content: "▼";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        font-size: 60%;
        line-height: 30px;
        color: #555;
        pointer-events:none;
        padding:2px 25px;
    }
}
.select-list select {
    outline:none; /* remove focus ring from Webkit */
    line-height: 1.2;
    -webkit-appearance:none; /* remove the strong OSX influence from Webkit */
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 0px;

    &:focus {
        -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, .6);
        -moz-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, .6);
        box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, .6);
    }
}
// IE fix
.select-list select::-ms-expand {
    display: none;
}

.init {
  opacity: 0;
}

.loaded {
  animation: fade-in 1s forwards;
}

@keyframes fade-in {
  from {
    opacity: 0
  }
  to {
    opacity: 1;
  }
  
}

</style>